import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';

const PublicRoute: React.FC = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return <Outlet />;
  }

  const role = localStorage.getItem(USER_ROLE_KEY);

  if (role === 'ep') {
    return <Navigate to="/ep-dashboard" replace />;
  }

  if (role === 'admin') {
    return <Navigate to="/admin-dashboard" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default PublicRoute;
